<script>
  import IconScale from "../IconScale.svelte";

  let { kind, leadingIcon, style = "border-radius:50%" } = $props();

  const backgroundColorMap = {
    success: "systemPositive_100",
    error: "systemError_100",
    warning: "systemWarning_100",
  };

  let backgroundColor = $derived(backgroundColorMap[kind] || "");
  const color = "textWhite";
  const size = "small";
</script>

{#if leadingIcon}
  <IconScale class={leadingIcon} {size} {backgroundColor} {color} {style} />
{/if}
